import { useFetchAllQueries } from '@/hooks/useFetchAllQueries';

import { mapPieChartData } from '../../utils/mappers';
import { CardWrapper } from '../cardWrapper';
import { PieChart } from './pieChart';
import { PieChartLoader } from './pieChartLoader';
import { CardVariantProps, PieChartVariant } from '../../types';

interface AdditionalProps {
  variantProps: PieChartVariant;
}

export const PieChartCard = ({
  columnFormatter,
  description,
  query,
  sx,
  title,
  variantProps,
}: CardVariantProps & AdditionalProps) => {
  const queryResult = useFetchAllQueries(query);

  return (
    <CardWrapper
      description={description}
      query={query.baseQuery}
      queryResult={queryResult}
      renderContent={(successfulResult) => {
        const mappedData = mapPieChartData(successfulResult.data, columnFormatter);

        return <PieChart data={mappedData} {...variantProps} />;
      }}
      renderLoading={() => <PieChartLoader />}
      sx={sx}
      title={title}
    />
  );
};
